export default function() {
  const widgetName = 'mainFeature';
  const widgetOpts = mainFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $('#mainFeature .card-widget-item').each(function(){
        var title = $(this).find('.card-widget-title');
        var titleText = title.text();
        var characterLimit = 45;

        if (titleText.length > characterLimit) {
          var trimmedText = titleText.substring(0, characterLimit) + '...';
          title.text(trimmedText);
        }

        var button = $(this).find('.buttonwrap a');
        button.addClass('button');
      });

      if ($('body').hasClass('saffireMobileSize')) {
        $('#mainFeature .moreButton').removeClass('button');
      } else {
        $('#mainFeature .moreButton').addClass('button');
      }

      $(window).resize(function(){
        if ($('body').hasClass('saffireMobileSize')) {
          $('#mainFeature .moreButton').removeClass('button');
        } else {
          $('#mainFeature .moreButton').addClass('button');
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['image'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 0,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: true, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      nav: false,
      autoplay: true
    },
    textOverImage: false
  });

}